import React from 'react';
import { Flex } from '../../../components';
import { Stack } from '@mui/material';
import TestTasksSelectableList from '../components/TestTasksSelectableList';
import PassTestTaskButton from '../components/PassTestTaskButton';
import { HackerRankDescription } from '../components/HackerRankDescription';
import { useFeatureFlags } from 'src/hooks/useFeatureFlags';
import { AvailableTestTaskWithPositionsData } from '@types';

interface IOneTTLayoutProps {
  testTaskSelected: string | null;
  testTasks: AvailableTestTaskWithPositionsData[];
  isPerformingAction: boolean;
  handleTTChange: (testTask: AvailableTestTaskWithPositionsData) => void;
  handlePassTTClick: () => void;
}

const OneTTLayout: React.FC<IOneTTLayoutProps> = ({
  testTaskSelected,
  testTasks,
  isPerformingAction,
  handleTTChange,
  handlePassTTClick,
}) => {
  const { isTTSelectionPageSimplified } = useFeatureFlags();

  return (
    <>
      <TestTasksSelectableList
        selectedTestTask={testTaskSelected}
        testTasks={testTasks}
        handleChange={handleTTChange}
      />
      <Stack spacing={3} direction="column" mt={4}>
        <Flex flexDirection="column" gap={4} alignItems="start">
          <PassTestTaskButton
            isDisabled={!testTaskSelected}
            isLoading={isPerformingAction}
            handlePassTTClick={handlePassTTClick}
          />
          {!isTTSelectionPageSimplified && <HackerRankDescription />}
        </Flex>
      </Stack>
    </>
  );
};

export default OneTTLayout;
